"use client";

import React from "react";
import dayjs from "dayjs";
import { CircleAlert, Radio } from "lucide-react";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const statusVariants = cva(
  "absolute -top-3 -right-1.5 inline-flex items-center gap-x-1 py-0.75 px-1.5 leading-0 rounded-sm",
  {
    variants: {
      variant: {
        live: "bg-class-live text-class-live-foreground",
        ended: "bg-class-ended text-class-ended-foreground",
        rescheduled: "bg-class-rescheduled text-class-rescheduled-foreground",
        cancelled: "bg-class-cancelled text-class-cancelled-foreground",
      },
    },
  }
);

function StatusIcon({ icon = () => null, variant, className, children }) {
  const IconComponent = icon;

  return (
    <span className={cn(statusVariants({ variant }), className)}>
      {/* eslint-disable-next-line react-hooks/static-components */}
      <IconComponent
        className={cn("size-3", { "animate-pulse": variant === "live" })}
      />
      <b className="font-normal text-xxxs leading-3">{children}</b>
    </span>
  );
}

function LiveClassStatus({ liveClass }) {
  const isEnded =
    dayjs().isSame(liveClass.endTime) || dayjs().isAfter(liveClass.endTime);

  // On Ended
  if (isEnded && liveClass.status !== 3) {
    return <StatusIcon variant="ended">Live Class Ended</StatusIcon>;
  }

  if (liveClass.live) {
    return (
      <StatusIcon variant="live" icon={Radio}>
        Live
      </StatusIcon>
    );
  }

  // On Re-Scheduled
  if (liveClass.status === 2) {
    return (
      <StatusIcon variant="rescheduled" icon={CircleAlert}>
        Re-Scheduled
      </StatusIcon>
    );
  }

  if (liveClass.status === 3) {
    return (
      <StatusIcon variant="cancelled" icon={CircleAlert}>
        Cancelled
      </StatusIcon>
    );
  }

  return null;
}

export default LiveClassStatus;
